import * as React from 'react';
import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { AxiosUtils } from '../../utils';
import { Guid, PartialBank } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';
import { useApi } from '../../context';

export function useBankPartialsQuery(
	search?: string,
	companyGuid?: Guid | undefined,
	options?: Omit<UseQueryOptions<PartialBank[], unknown, PartialBank[], string[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.BankPartials(search, companyGuid),
		() =>
			AxiosUtils.getResponseData<PartialBank[]>(
				api.get(CerebroApiEndpoints.Lookups.BankPartials(search, companyGuid))
			),
		{ ...options, enabled: (search?.length ?? 0) >= 3 && (options?.enabled ?? true) }
	);
}
